var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEmptyChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_5488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.261 93.8182C108.56 87.0595 111.994 78.7041 111.994 69.9987C111.994 59.1061 106.613 49.2415 97.9954 42.2422C97.7986 67.199 74.3291 87.497 45.5008 87.497H25.9902C33.5363 99.9426 48.8692 108.495 66.4986 108.495H108.494C109.916 108.495 111.185 107.642 111.732 106.329C112.278 105.017 111.972 103.508 110.966 102.524L102.261 93.8182Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5011 3.50537C20.413 3.50537 0.00569282 20.763 0.00569282 42.0015C0.00569282 50.7068 3.43972 59.0403 9.73908 65.8209L1.03371 74.5263C0.0275656 75.5324 -0.278653 77.0416 0.268166 78.3321C0.814986 79.6445 2.08361 80.4975 3.50534 80.4975H45.5011C70.5891 80.4975 90.9964 63.2399 90.9964 42.0015C90.9964 20.763 70.5891 3.50537 45.5011 3.50537Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4993 31.5024H24.5036C22.5787 31.5024 21.0039 33.0773 21.0039 35.0021C21.0039 36.9269 22.5787 38.5017 24.5036 38.5017H66.4993C68.4241 38.5017 69.9989 36.9269 69.9989 35.0021C69.9989 33.0773 68.4241 31.5024 66.4993 31.5024ZM52.5007 45.501H24.5036C22.5787 45.501 21.0039 47.0759 21.0039 49.0007C21.0039 50.9255 22.5787 52.5003 24.5036 52.5003H52.5007C54.4255 52.5003 56.0004 50.9255 56.0004 49.0007C56.0004 47.0759 54.4255 45.501 52.5007 45.501Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_5488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyChat);
export default __webpack_public_path__ + "static/media/ic_empty_chat.7b17e61909df49aca92ca56a723cc405.svg";
export { ForwardRef as ReactComponent };